module.exports = __webpack_public_path__ + "static/img/14000689.faa9ce10.png";